// extracted by mini-css-extract-plugin
module.exports = {"spinner":"spinner_spinner__21x4r","spinner-message":"spinner_spinner-message__1uAre"};